 export const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href="/"
  };